import { createButton } from 'react-simple-wysiwyg';

import { LeftIndent01Icon } from '@/assets/icons/LeftIndent01Icon';

export default createButton('Left Indent', <LeftIndent01Icon />, 'indent');
